import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { TextComponent } from 'library/components/data-table/data-table';

const Organizations = ({ record }) => {
  const orgs = resolve(record, 'organizations_requests', []);
  let orgText = '';
  if (orgs.length === 1) {
    orgText = orgs[0].name;
  } else {
    orgText = `${orgs.length} Organizations`;
  }
  return <TextComponent data={orgText} />;
};

export default Organizations;
